import { useEffect, useRef, useState } from "react";
import { isScreenAwake, onScreenChange, startScreenWatch } from "../utils/screenAwake";

// Meet of de tv beeld geeft (utils/screenAwake.js). onWake krijgt hoe lang
// het donker was, onDark het moment waarop het beeld wegviel.
export function useScreenAwake({ onWake, onDark } = {}) {
  const [awake, setAwake] = useState(isScreenAwake);

  // Via een ref, zodat nieuwe handlers de meting niet herstarten.
  const handlers = useRef({});
  handlers.current = { onWake, onDark };

  useEffect(() => {
    const stop = startScreenWatch();
    const off = onScreenChange(({ awake: now, sleptMs, darkAt }) => {
      setAwake(now);
      if (now) handlers.current.onWake?.({ sleptMs, darkAt });
      else handlers.current.onDark?.({ darkAt });
    });

    return () => {
      off();
      stop();
    };
  }, []);

  return awake;
}
